import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { icons, LucideAngularModule, LucideIconData } from 'lucide-angular';

/**
 * Simple icon wrapper component using Lucide icons
 *
 * Usage:
 *   <app-icon name="menu" />
 *   <app-icon name="home" size="20" />
 *   <app-icon name="alert-circle" [color]="'var(--fg-danger)'" />
 */
@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: './icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './icon.component.css',
})
export class IconComponent {
  /** Icon name from Lucide library */
  @Input() name!: string;

  /** Icon size in pixels (default: 24) */
  @Input() size = 24;

  /** Icon color (default: currentColor - inherits text color) */
  @Input() color = 'currentColor';

  /** Stroke width (default: 2) */
  @Input() strokeWidth = 2;

  /** Fill icon interior with currentColor when true (useful for active stars, hearts, etc.) */
  @Input() filled = false;

  /** Get the Lucide icon data */
  get icon(): LucideIconData {
    return (icons as any)[this.camelCaseName];
  }

  /** Convert kebab-case to camelCase for Lucide icon names */
  private get camelCaseName(): string {
    return this.name
      .split('-')
      .map((word, index) =>
        index === 0
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word.charAt(0).toUpperCase() + word.slice(1),
      )
      .join('');
  }
}
